import { render, staticRenderFns } from "./Wan.vue?vue&type=template&id=80a7074e&"
import script from "./Wan.vue?vue&type=script&lang=js&"
export * from "./Wan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports